export const list = [
  {
    id: '1',
    question: 'What is Themis Premium?',
    answer: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officiis, assumenda.',
  },
  {
    id: '2',
    question: 'Can I get a refund if I don`t like it?',
    answer:
      'We want everyone to have a great experience with Themis Premium. If you`re not satisfied during your first week, please contact us and we will issue you a full refund.',
  },
  {
    id: '3',
    question: 'How many Discord servers is my subscription valid for?',
    answer:
      'A subscription is valid for a single Discord server. Premium subscription is not transferable.',
  },
  {
    id: '4',
    question: 'What payment methods do you accept?',
    answer: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officiis, assumenda.',
  },
  {
    id: '5',
    question: 'Will I be billed automatically every month?',
    answer: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officiis, assumenda.',
  },
  {
    id: '6',
    question: 'How long does it take for my premium features to activate after purchase?',
    answer: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officiis, assumenda.',
  },
];
